
import BasicState from "src/libs/basic-view"
import LocalWorksForm from "./local-works/LocalWorksForm"
import BasicViewForm from "./local-works/BasicViewForm"

export default class LocalWorksView extends BasicState {
    props: any
    addRender = () => {
        return <div className="d-flex w-100 m-0 position-relative">
            <LocalWorksForm {...this.props} />  
            {/* <BasicViewForm {...this.props} />   */}
        </div>
    }
}